module.exports = __webpack_public_path__ + "4143cea9373e63f492cac522c7913994.png";